module.exports = __webpack_public_path__ + "media/front/ico-checkbox-check-fde6bd7f.svg";